import { Injectable } from "@angular/core";
import { environment } from "environments/environment";
import { Observable } from "rxjs";
import { HttpService } from "services/http.service";
import { EthicsChannelConfigModel } from "services/models/corporate/ethics-channel/ethics-channel-config.model";
import { QueryParams } from "services/models/odata/queryParams";
import { ServiceBase } from "services/servicebase";
import { Response } from "services/models/response";
import { map } from "rxjs/operators";
import { HttpParams } from "@angular/common/http";

@Injectable()
export class EthicsChannelConfigService extends ServiceBase<EthicsChannelConfigModel> {
  constructor(http: HttpService) {
    super("ethicschannel/config", http, environment.apiUrl);
  }

  createEntity(input: any): EthicsChannelConfigModel {
    return EthicsChannelConfigModel.create(input);
  }

  listConfig(
    queryParams: QueryParams
  ): Observable<Response<EthicsChannelConfigModel[]>> {
    return this.http
      .get(
        `${this.endpoint}/list${this.createBuildQuery(queryParams)}`,
        null,
        null,
        null,
        true
      )
      .pipe(
        map((res) => {
          const response = new Response<EthicsChannelConfigModel[]>();
          response.data = res.body.map((pp: any) => {
            return EthicsChannelConfigModel.create(
              pp
            ) as EthicsChannelConfigModel;
          });
          response.count = res.headers.get("x-count");
          return response;
        })
      );
  }

  getByCompanyGroupId(id: string = null): Observable<EthicsChannelConfigModel> {
    let params = new HttpParams();
    if (id) params = params.set("companyGroupId", id);
    return this.http
      .get(`${this.endpoint}/by-company-group`, { params }, null, null, true)
      .pipe(
        map((data: any) =>
          data.body === null ? new EthicsChannelConfigModel() : data.body
        )
      );
  }

  createOrUpdate(data: EthicsChannelConfigModel): Observable<any> {
    if (data?.id) {
      return this.http.put(`${this.endpoint}/update`, data);
    }

    return this.http.post(`${this.endpoint}/create`, data, null, null, true);
  }
}
